import React from 'react';
import { ResultOverviewGrid } from './shared.styles';

// Product-agnostic layout shell for the top-of-result-page row: a 2/3 grid
// (1 column on mobile) holding whichever subject card (vehicle, moto,
// profession, ...) and whichever quote-cost-summary card the calling
// screen passes in as children. This component never needs to know which
// product it's rendering for — each screen decides that by which cards it
// composes here, so adding a product never means editing this file.
function ResultOverviewRow({ children }) {
  return <ResultOverviewGrid>{children}</ResultOverviewGrid>;
}

export default ResultOverviewRow;
